
import React, { Component, PureComponent } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import {
	Link,
} from 'react-router-dom'

import { CheckBox, Radio } from "../Forms/Forms";
import { setServices, CurrentStepSetAction, selectedServices } from '../../actions/action';


const mapStateToProps = state => state;
const mapDispatchToProps = { setServices, CurrentStepSetAction, selectedServices };

class PremiumServiceItem extends PureComponent {
	_isMounted = false;
	static defaultProps = {
		Title: "",
		Price: "",
		Description: "",
		Name: "item",
		isSelected: false
	};
	constructor(props) {
		super(props);
		this.state = {
			pageLoaded: false,
		};

	}
	componentWillMount() {
		this._isMounted = true;
	}
	componentDidMount() {
		window.scrollTo(0, 0);


	}


	componentWillUnmount() {
		this._isMounted = false;
	}
	render() {

		return (
			<React.Fragment>
				<div className="premium_services-item">
					<div className="item-title">
						<h4 tabIndex="0" className="item-title-name">{this.props.Title} </h4>

						<span dangerouslySetInnerHTML={{ __html: (this.props.Price) }}></span>
					</div>
					<div className="item-body">

						<p tabIndex="0" className="item-body-content" dangerouslySetInnerHTML={{ __html: (this.props.Description) }}></p>
						<CheckBox
							name={this.props.Name}
							id={this.props.Name}
							label={this.props.Label}
							defaultValue="y"
							disabled={this.props.Disabled}
							isChecked={this.props.isSelected}
							onClick={(e) => { this.props.onChange(e) }}
						/>


					</div>
				</div>
			</React.Fragment>
		);
	}
}
export default connect(mapStateToProps, mapDispatchToProps)(PremiumServiceItem);
